import * as UnitDivide from "../unit-divide";
import { Lumen } from "./luminous-flux";
import { SquareMeter } from "./area";
/**
 * The derived unit for illuminance ( <code>lx</code> ).
 * One Lux is equal to one lumen per square meter.
 */
export var Lux = UnitDivide.luminousFluxByArea("Lux", Lumen, SquareMeter);
//# sourceMappingURL=illuminance.js.map